// extracted by mini-css-extract-plugin
module.exports = {"large":"_3dqi4IXw1x2m2CZtHSGcRk","default":"Y-6M4MvSIdWpupz1vb3sx","small":"_3Lm-0gYiFwDysfs38Xloao","cancel":"_1Oqk1bEn7dEUuKRTWvU9Ct"};